import { Autocomplete, CircularProgress, debounce, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { OverallDataContext } from "../../pages/CalculatorPage";

export default function AddressField({ id_name, category, onChangeHandler, isRequired, errorMsg, setFocus, isReadOnly, adrType=null }) {
    const placeholderData = useContext(OverallDataContext).placeholderData;
    const calcStage = useContext(OverallDataContext).calcStage[0];
    
    const [inputValue, setInput] = useState(''); // To track user input
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tempPlaceholder, setPlaceholder] = useState(''); // To stash the initial precalculated value

    const fetchAddresses = (address) => {
        if (address) {
            setLoading(true);
            const apiKey = process.env.REACT_APP_GOOGLE_APIKEY;
            const url = `https://places.googleapis.com/v1/places:autocomplete`

            fetch(url, 
            {
                method: 'POST',
                body: JSON.stringify({
                    input: address,
                    locationBias: { // to limit to Singapore region only, rough estimate based on Google Maps
                        rectangle: {
                            low: {
                                latitude: 1.13,
                                longitude: 103.6
                            },
                            high: {
                                latitude: 1.50,
                                longitude: 104.1
                            }
                        }
                    },
                    includedPrimaryTypes: adrType,
                    includedRegionCodes: "sg"
                }),
                headers: {
                    'X-Goog-Api-Key': apiKey,
                    // 'X-Goog-FieldMask': '*',
                    'X-Goog-FieldMask': 'suggestions.placePrediction.placeId,suggestions.placePrediction.text.text',
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            })
            .then(response => response.json())
            .then(data => {
                if (data.suggestions) {
                    setOptions(data.suggestions.map((suggestion) => ({
                        label: suggestion.placePrediction?.text?.text, // The description of the place
                        value: suggestion.placePrediction?.placeId, // The unique identifier for the place
                    })))
                } else {
                }
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
        }
    }
    const debouncedFetch = debounce(fetchAddresses, 1000);

    const handleInputChange = (newInputValue) => {
        setInput(newInputValue);
        if (newInputValue.trim() !== '') {
            // TODO TEMP DISABLE uncomment this once done debugging everything
            debouncedFetch(newInputValue);
          
            const fieldData = {
                name: id_name,
                value: newInputValue,
            }
            onChangeHandler(fieldData);
        } else {
          setOptions([]);
        }
    };

    const handleSelect = (option) => {
        let field_value = option?.label || '';
        setInput(field_value);

        const fieldData = {
            name: id_name,
            value: field_value,
        }
        onChangeHandler(fieldData);
    }
    
    useEffect(()=>{
        let stateVal = placeholderData?.[category]?.[id_name] || null;
        if (stateVal) setPlaceholder(stateVal);
        else setPlaceholder('');
        
        if (stateVal && calcStage!==1) setInput(stateVal);
        else setInput('');
    }, [calcStage, placeholderData, id_name]);

    return (
        <Autocomplete
            id={ id_name }
            freeSolo
            fullWidth
            autoSelect
            openOnFocus
            options={options}
            getOptionLabel={(option) => ( option !== undefined ? (
                option.label
            ) : '' ) || '' }
            forcePopupIcon={(options != null && options.length > 0)}
            inputValue={inputValue}
            onInputChange={(event, input_value, reason) => {
                if (reason === 'clear') handleInputChange("");
                if (reason === 'input') handleInputChange(input_value);
            }}
            onChange={(event, option_selected, reason) => {
                if (reason === 'selectOption') handleSelect(option_selected);
            }}
            disabled={isReadOnly}
            readOnly={isReadOnly}

            renderInput={(params) => 
                <TextField {...params}
                    name={ "af"+id_name } id={ "af"+id_name }
                    type="text"
                    placeholder={tempPlaceholder}
                    onFocus={() => setFocus(true)}
                    onBlur={() => setFocus(false)}
                    required={isRequired}
                    error={(errorMsg !== '')}
                    helperText={errorMsg ? errorMsg : ''}
                    fullWidth
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: !isReadOnly && (
                          <>
                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                    }}
                    sx={{ paddingY: 0 }}
                    size="small"
                />
            }
        />
    )
}